import { login, logout, getUserSso } from '@/api/login';
// import utils from '@/utils/index';
import {
  getToken, setToken, removeToken,
  setRefreshToken, removeRefreshToken,
  getlocalStorage, setlocalStorage, removelocalStorage
} from '@/utils/storage';
import {
  getUserInfoDetail,
  getportalInfo,
  getportalNav,
  getportalManagementUrl,
  getOaMessage
} from '@/api/user';
const user = {
  state: {
    token: getToken() || '',
    loginInfo: getlocalStorage('loginInfoPorta') || {},
    userInfo: getlocalStorage('userInfoPorta') || {},
    portalInfo: getlocalStorage('portalInfo') || {},
    oaMessage: getlocalStorage('oaMessage') || {},
    hearderNavList: [],
    footerNavList: [],
    orgList: [],
    resultCountClick: '',
    manageSsoUrl: {},
    loginShow: false
  },

  mutations: {
    SET_COUNT: (state, data) => {
      state.resultCountClick = data;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_REFRESHTOKEN: (state, refreshToken) => {
      state.refreshToken = refreshToken;
    },
    SET_LOGININFO: (state, loginInfo) => {
      state.loginInfo = loginInfo;
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    SET_PORTALINFO: (state, portalInfo) => {
      state.portalInfo = portalInfo;
      document.title = portalInfo.title;
    },
    SET_MANAGEURL: (state, data) => {
      state.manageSsoUrl = data;
      setlocalStorage('manageSsoUrl', data);
    },
    SET_LOGINSHOW: (state, data) => {
      state.loginShow = data;
    },
    SET_OAMESSAGE: (state, oaMessage) => {
      const oaMag = oaMessage;
      if (oaMag && oaMag.oaUrl) {
        oaMag.oaUrl = oaMag.oaUrl + getToken();
      }
      setlocalStorage('oaMessage', oaMag);
      state.oaMessage = oaMag;
    },
    SET_PORTALNav: (state, data) => {
      const hearderNavList = [];
      const footerNavList = [];

      data.forEach(element => {
        if (element.type === 2) {
          footerNavList.push(element);
        } else {
          hearderNavList.push(element);
        }
      });
      state.hearderNavList = hearderNavList;
      state.footerNavList = footerNavList;
    }
  },

  actions: {

    // 登录
    Login({ commit }, loginInfo) {
      const account = loginInfo.account.trim();
      return new Promise((resolve, reject) => {
        login(account, loginInfo.pwd).then(response => {
          const data = response.data;
          // const currentOrg = data.manageOrgs && data.manageOrgs.length > 0 ? data.manageOrgs.sort(utils.compare('level'))[0] : {};
          setToken(data.accessToken);
          setRefreshToken(data.refreshToken);
          setlocalStorage('loginInfoPorta', data);
          commit('SET_TOKEN', data.accessToken);
          commit('SET_REFRESHTOKEN', data.refreshToken);
          commit('SET_LOGININFO', data);
          resolve(data);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 获取门户详细信息
    FetchportalInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getportalInfo()
          .then(result => {
            setlocalStorage('portalInfo', result.data);
            commit('SET_PORTALINFO', result.data);
            resolve();
          }).catch(error => {
            reject(error);
          });
      });
    },
    // 获取门户导航
    FetchportalNav({ commit }) {
      return new Promise((resolve, reject) => {
        getportalNav()
          .then(result => {
            commit('SET_PORTALNav', result.data);
            resolve();
          }).catch(error => {
            reject(error);
          });
      });
    }, // 获取门户导航
    FetchManageUrl({ commit }) {
      return new Promise((resolve, reject) => {
        getportalManagementUrl()
          .then(result => {
            commit('SET_MANAGEURL', result.data);
            resolve(result.data);
          }).catch(error => {
            reject(error);
          });
      });
    },
    FetchOaMessage({ commit }) {
      return new Promise((resolve, reject) => {
        getOaMessage()
          .then(result => {
            commit('SET_OAMESSAGE', result.data);
            resolve(result.data);
          }).catch(error => {
            commit('SET_OAMESSAGE', {});
            reject(error);
          });
      });
    },
    // 获取用户详细信息
    GetUserInfo({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        getUserInfoDetail()
          .then(result => {
            setlocalStorage('userInfoPorta', result.data);
            commit('SET_USERINFO', result.data);
            dispatch('FetchManageUrl');
            dispatch('FetchOaMessage').then(() => {
              resolve(result.data);
            });
          }).catch(error => {
            reject(error);
          });
      });
    },
    // 获取用户详细信息
    GetUserSso({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        getUserSso()
          .then(result => {
            setToken(result.data.accessToken);
            commit('SET_TOKEN', result.data.accessToken);
            setlocalStorage('userInfoPorta', result.data);
            commit('SET_USERINFO', result.data);
            dispatch('FetchManageUrl');
            dispatch('FetchOaMessage').then(() => {
              resolve();
            });
          }).catch(error => {
            reject(error);
          });
      });
    },
    // 后端 登出
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_TOKEN', '');
          commit('SET_REFRESHTOKEN', '');
          commit('SET_LOGININFO', {});
          commit('SET_USERINFO', {});
          removeToken();
          removeRefreshToken();
          removelocalStorage('userInfoPorta');
          removelocalStorage('loginInfoPorta');
          removelocalStorage('portalInfo');
          removelocalStorage('oaMessage');
          removelocalStorage('manageSsoUrl');
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },

    //  前端登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '');
        commit('SET_LOGININFO', {});
        commit('SET_USERINFO', {});
        removeToken();
        removeRefreshToken();
        removelocalStorage('userInfoPorta');
        removelocalStorage('loginInfoPorta');
        removelocalStorage('portalInfo');
        removelocalStorage('oaMessage');
        removelocalStorage('manageSsoUrl');
        resolve();
      });
    }

  }
};

export default user;
